/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * @component   : BuildingMain
 * @description : This component manages the Building system. It handles the creation,
 *                update, pagination and search of the building records.
 *                It provides a dynamic table interface for managing building records.
 *
 * @renders     : - A searchable and interactive building table
 *                - Add button (based on user permissions)
 *
 * @features    : - Custom table with the actions menu of each building
 *                - Search input
 *                - Role-based permission checks
 *                - Modularized actions and table handling
 */

import HeadTittle from '../../components/HeadTittle';
import NotInformation from '../../components/NotInformation';
import SearchSimple from '../../components/SearchSimples/SearchSimple';
import ButtonAction from '../../components/buttons/ButtonAction';
import {AddIcon} from '../../components/buttons/IconButtons';
import CustomExpandableTable from '../../components/table/CustomExpandableTable';
import BuildingMainApp from './BuildingMainApp';
import React from "react";
import CreateBuildingModal from "./Modal/CreateBuildingModal";
import UpdateBuildingModal from "./Modal/UpdateBuildingModal";
import CopyBuildingLinkModal from "./Modal/CopyBuildingLinkModal";

const BuildingMain = () => {
    const {
        t,
        createModal,
        setCreateModal,
        updateModal,
        setUpdateModal,
        invitationLinkModal,
        setInvitationLinkModal,
        selected,
        setSelected,
        modified,
        setModified,
        DEV,
        permission,
        canCreate,
        columns,
        results,
        setResults,
        searchElement,
        setSearchElement,
        setSearch,
        option,
        searchId,
        rowsPerPage,
        simpleSearch,
        setSimpleSearch,
        setBodyForExport,
        contractorId,
        supplierId,
        pagination,
        renderOptionsMenu,
        renderExpandedRow
    } = BuildingMainApp();


    return (
        <>
            <HeadTittle name={'buildings'}>
                {canCreate &&
                    <ButtonAction
                        id='btn_bm_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => setCreateModal(true)}
                    />
                }
            </HeadTittle>

            <SearchSimple
                id={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchResults={results}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
            />

            {results?.content?.length > 0 ? (
                <>
                    {/**Done*/}
                    <CustomExpandableTable
                        columns={columns}
                        rows={results?.content || []}
                        renderExpandedRow={renderExpandedRow}
                        renderOptionsMenu={renderOptionsMenu}
                        checkbox={false}
                    />
                    {pagination()}
                </>
            ) : (
                <NotInformation
                    className={"mt-4"}
                    card={true}
                    text={typeof results?.content === "undefined" ? t('loading') : t('you_haven_not_created_any_building_yet')}
                    showButton={canCreate}
                    buttonId={'btn_bm_link_create'}
                    buttonOnclick={() => setCreateModal(true)}
                    buttonTrans={'create_new_building'}
                    searchElement={searchElement !== ''}
                />
            )}

            {createModal &&
                <CreateBuildingModal
                    title={t('create_building')}
                    show={createModal}
                    onHide={() => setCreateModal(false)}
                    modified={modified}
                    setModified={setModified}
                />
            }

            {updateModal &&
                <UpdateBuildingModal
                    title={t('update_building')}
                    show={updateModal}
                    onHide={() => setUpdateModal(false)}
                    building={selected}
                    modified={modified}
                    setModified={setModified}
                />
            }

            {invitationLinkModal && selected &&
                <CopyBuildingLinkModal
                    show={invitationLinkModal}
                    setShow={setInvitationLinkModal}
                    itemSelected={selected}
                    setItemSelected={setSelected}
                />
            }
        </>
    );
};

export default BuildingMain;

